export default __webpack_public_path__ + "static/media/1.5cce6479.jpeg";